import { type FC } from "react"

import Certificate, { CertificateLine, CertificateValue } from "@forento/ui/components/Certificate"
import Modal from "@forento/ui/components/Modal"

import Button from "~/components/Button"
import { CloseIcon } from "~/components/Icon"
import { usePlatform, useUser } from "~/contexts/UserContext"

type Props = { courseTitle: string; isOpen: boolean; onClose(): void }
const Preview: FC<Props> = ({ courseTitle, isOpen, onClose }) => {
	const user = useUser().user!
	const platform = usePlatform()!

	return (
		<Modal isOpen={isOpen} width={900} onClose={onClose} ariaLabel="Certificate preview">
			<div className="relative">
				<Certificate
					accentColor={platform.primaryColor.value}
					issuerName={platform.name}
					logo={platform.logo}
					title="Certificate of completion"
				>
					<CertificateLine>This is to certify that</CertificateLine>
					<CertificateValue>
						{user.firstName} {user.lastName}
					</CertificateValue>
					<CertificateLine>has successfully completed the course</CertificateLine>
					<CertificateValue>{courseTitle}</CertificateValue>
					<CertificateLine>
						on {new Intl.DateTimeFormat(platform.language, { dateStyle: "long" }).format(new Date())}
					</CertificateLine>
				</Certificate>
				<Button
					className="absolute top-7 right-7 size-9 items-center justify-center rounded-full bg-white/90 p-2 shadow-sm"
					onClick={onClose}
				>
					<CloseIcon className="size-full" />
				</Button>
			</div>
		</Modal>
	)
}

export default Preview
